import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { CONFIG } from 'src/global-config';

import { Image } from 'src/components/image';
import { AnimateCountUp } from 'src/components/animate';
import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

const iconPath = (name) => `${CONFIG.assetsDir}/assets/icons/travel/${name}`;

const SUMMARY = [
  { total: 5000, description: 'Clients', icon: 'mdi:account-group', type: 'iconify' },
  { total: 45000, description: 'Orders', icon: 'mdi:package-variant-closed', type: 'iconify' },
  {
    total: 150000,
    description: 'Search Inquiries',
    icon: 'mdi:magnify',
    type: 'iconify',
  },
  {
    total: 877,
    description: 'Verified hotels',
    icon: iconPath('ic-verified-hotels.svg'),
    type: 'iconify',
  },
];

// ----------------------------------------------------------------------

export function BreafAbout({ sx, ...other }) {
  const renderTexts = () => (
    <Box sx={{ mx: 'auto', maxWidth: 480, mb: { xs: 5, md: 10 } }}>
      <Typography variant="h2">Who we are</Typography>
      <Typography sx={{ mt: 3, color: 'text.secondary' }}>
        SHAHEN provides truck rental service of all sizes and types, and a selection of trained and
        professional drivers. In addition, we provide you with insurance on your shipments and goods
        as SHAHEN takes care of your goods until it reaches its destination and are delivered.
      </Typography>
    </Box>
  );

  const renderList = () => (
    <Box
      sx={{
        gap: 3,
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
      }}
    >
      {SUMMARY.map((value) => (
        <Box
          key={value.description}
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            color: 'text.secondary',
          }}
        >
          {value.type === 'iconify' ? (
            <Iconify
              icon={value.icon}
              width={64}
              height={64}
              color="#28a745"
              style={{ marginBottom: 16 }}
            />
          ) : (
            <Image
              alt={value.description}
              src={value.icon}
              disablePlaceholder
              ratio="1/1"
              sx={{ mb: 3, width: 80 }}
            />
          )}

          <AnimateCountUp
            variant="h3"
            to={value.total}
            toFixed={0}
            sx={{ mb: 1, color: 'text.primary' }}
          />
          {value.description}
        </Box>
      ))}
    </Box>
  );

  return (
    <Box
      component="section"
      sx={[
        {
          textAlign: 'center',
          py: { xs: 5, md: 10 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        {renderTexts()}
        {renderList()}
      </Container>
    </Box>
  );
}
